module.exports = __webpack_public_path__ + "img/maps_icon_pin_blue.a1080bc0.png";